module.exports = __webpack_public_path__ + "media/images/van-background-8ffae4a48414d115ca66ac3f32d43ccf.jpg";